export const SITE_MAIN_URL = `https://www.applestone.com/`
export const SITE_URL = `https://register.betaadmin.com/`
export const SITE_NAME = `New Tenant Registration`

export const SEO_TITLE_SUFFIX = ` – Applestone Solutions`

export const DEFAULT_SEO = {
  title: SITE_NAME,
  description: ``,
  keywords: ``,
  url: SITE_URL,
  siteName: ``,
  img: `android-chrome-512x512.png`
}

const siteUrl = (path) => {
  return `${SITE_URL}${path}`
}

export const SEO = {
  thankYou: {
    title: `Thank You`,
    url: siteUrl(`/thank-you`),
  },
  privacyPolicy: {
    title: `Privacy Policy`,
    url: siteUrl(`/privacy-policy`),
  },
  page404: {
    title: `404`,
    url: siteUrl(`/404`),
  },
}
